import { DecimalPipe, HashLocationStrategy, LocationStrategy, registerLocaleData } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import localeBr from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule,APP_INITIALIZER } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { ChartModule } from 'primeng/chart';
import { CalendarModule, CardModule, ConfirmationService, ConfirmDialogModule, DialogModule, GrowlModule } from 'primeng/primeng';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SetupService } from './configuracoes/setup/setup.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './dashboard/dashboard.service';
import { LoginComponent } from "./login/login.component";
import { UsuarioService } from "./seguranca/usuario/usuario.service";
import { AuthGuard } from "./shared/auth/auth.guard";
import { AuthService } from "./shared/auth/auth.service";
import { GlobalsVariablesService } from './shared/service/global-variables.service';
import { MessageService } from './shared/service/message.service';
import { RowMaskService } from './shared/service/row-mask.service';
import { SelecaoDataTableService } from "./shared/service/selecao-data-table.service";
import { ViewComponent } from './view/view.component';
import { AppInitService } from './app-init.service';
import { ProdutoService } from './estoque/produto/produto.service';
import { PedidoService } from './comercial/pedido/pedido.service';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { DashboardModernComponent } from './dashboard/modern/dashboard-modern.component';


// the second parameter 'fr' is optional 
registerLocaleData(localeBr, 'pt');

export function init_app(appLoadService: AppInitService) {
  return () => appLoadService.init();
}

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToggleButtonModule, 
    FormsModule,
    ReactiveFormsModule,
    GrowlModule,
    CalendarModule,
    AppRoutingModule,
    ConfirmDialogModule,
    DialogModule,
    CardModule,
    ChartModule
    
  ],
  declarations: [
    AppComponent,
    LoginComponent,
    ViewComponent,
    DashboardComponent,
    DashboardModernComponent
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: LOCALE_ID, useValue: 'pt' },    
    DashboardService,
    DecimalPipe,
    RowMaskService,
    GlobalsVariablesService,
    SetupService,
    AuthService,
    AuthGuard,
    CookieService,
    MessageService,
    UsuarioService,
    ConfirmationService,
    SelecaoDataTableService,
    PedidoService,
    SetupService,
    AppInitService,
    { provide: APP_INITIALIZER  ,
      useFactory: init_app,
      deps: [AppInitService],
      multi: true } 
  ],
  bootstrap: [
    AppComponent
  ]
})

export class AppModule {
}
